var codeblock_default = {
  "blockStyleSpacing": "_9CFNO",
  "codeBlock": "rshBu _9CFNO",
  "renderedInTable": "HvDUW"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
